export const ICON_FONT_SIZE = '14px';
export const BRAND_COLOUR = '#ae00ff';
